import { DoughnutChart, FoodsIcon } from "@foodpilot/foods";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useScoreDetailContext } from "src/context/ScoreDetail/useScoreDetailContext";
import i18n from "src/i18n";
import { formatNumber } from "src/utils/formatting";
import { CommonChartProps } from "../chart.types";
import { PrevScoreLayout } from "./PrevScoreLayout";

type DoughnutChartAcc = {
    values: number[];
    labels: string[];
    actions: Array<(() => void) | undefined>;
};

type DistributionChartProps = CommonChartProps;
export const DistributionChart = (props: DistributionChartProps) => {
    const {
        scoreList: { lastSelected },
    } = useScoreDetailContext();
    const theme = useTheme();

    const { data, total } = props;
    const currentTotalScore = total?.score.value ?? null;
    const prevTotalScore = total?.score.prev ?? null;

    const chartAcc: DoughnutChartAcc = {
        values: [],
        labels: [],
        actions: [],
    };

    const chartValues = data.reduce((prevAcc, currentValue) => {
        const score = currentValue.score.value;
        const label = currentValue.title;
        const action = currentValue.action;

        if (score === null) return prevAcc;

        prevAcc["values"].push(score);
        prevAcc["labels"].push(label);
        prevAcc["actions"].push(action);
        return prevAcc;
    }, chartAcc);

    const _total = formatNumber(currentTotalScore ?? 0, i18n.resolvedLanguage);

    return (
        <PrevScoreLayout total={currentTotalScore} prevScore={prevTotalScore}>
            <DoughnutChart
                createPalette={false}
                colors={theme.custom.dataviz.onlyMainFromAll}
                values={chartValues.values}
                valuesFormatterFn={(value) => formatNumber(value, i18n.resolvedLanguage)}
                labels={chartValues.labels}
                valuesUnit={lastSelected.unit}
                fullWidthLegend={true}
                spacing={5}
                borderWidth={2}
                borderColor={theme.palette.common.white}
                displayTotal={_total}
                legend={{
                    position: "right",
                    actions: chartValues.actions,
                    seeMore: <ChartLegend />,
                }}
            />
        </PrevScoreLayout>
    );
};

const ChartLegend = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <>
            <Box sx={{ mr: theme.spacing(1), width: "100%" }}>{t("See details")}</Box>
            <FoodsIcon size={1} icon="arrowRight" />
        </>
    );
};
